export default __webpack_public_path__ + "static/media/open_detail_view.d0021d57.mp3";